import { ErrorResponse } from '~shared/models';
import { Category } from '~app/modules/generic/models';

export interface CategoryState {
  payload: Category;
  loading: boolean;
  error: ErrorResponse;
}

export const categoryInitialState: CategoryState = {
  payload: null,
  loading: false,
  error: null,
};
